// Components
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const DoggyPacksDetailsPage = () => import(/* webpackPrefetch: true, webpackChunkName: "doggy-packs-details-page" */ '@/app/views/client-view/doggy-pack-page/components/doggy-packs-details-page/doggy-packs-details-page.vue');

// Mixins
import { googleTagManagerMixins } from '@/app/mixins/utils/google-tag-manager-mixins';

export default {
    name: 'DoggyPacksDetailsContainer',
    mixins: [ googleTagManagerMixins ],
    components: {
        ClientHeader,
        TheFooter,
        DoggyPacksDetailsPage,
    },
    computed: {
        isNativeApp() {
            return this.$store.getters.getIsNativeApp;
        },
    },
    data() {
        return {
            hasLatitudePay: false,
            showMainLogo: true
        };
    },
}